import React from 'react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import { Button, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import api from '../../api';
import './index.css';

export default class LocationMetricsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site: this.props.site,
      metricsSettings: null,
      fromYearMonth: '',
      toYearMonth: '',
      salesTimeSeriesMetrics: [],
      usersTimeSeriesMetrics: [],
      financialTimeSeriesMetrics: [],
      customerSupportTimeSeriesMetrics: [],
    };
  }
  componentDidMount() {
    this.loadData();
  }
  loadData() {
    this.getLocationTimeSeriesMetrics('sales', 'salesTimeSeriesMetrics');
    this.getLocationTimeSeriesMetrics('users', 'usersTimeSeriesMetrics');
    this.getLocationTimeSeriesMetrics('financial', 'financialTimeSeriesMetrics');
    this.getLocationTimeSeriesMetrics('customer_support', 'customerSupportTimeSeriesMetrics');
  }
  getLocationTimeSeriesMetrics(metricsGroup, stateToSet) {
    const { site } = this.props;
    const {
      fromYearMonth,
      toYearMonth,
    } = this.state;
    api.fetchAPI({
      method: 'get',
      uri: `location_metrics/${site.id}/${metricsGroup}?from=${fromYearMonth}&to=${toYearMonth}`,
      success: (response) => {
        const state = {};
        state[stateToSet] = this.dataTransform(response.result, response.metrics_settings);
        this.setState(state);
      },
    });
  }
  dataTransform(timeSeriesMetrics, metricsSettings) {
    const timeSeriesMetricsTransformed = [];
    Object.keys(timeSeriesMetrics).forEach((key, index) => {
      const currentKeyData = timeSeriesMetrics[key];

      let metricsSetting = {};
      console.log('metricsSettings', metricsSettings);
      if (metricsSettings && metricsSettings != {}) {
        console.log('metricsSettingsKey', metricsSettings[key]);
        if (metricsSettings[key]) {
          metricsSetting = metricsSettings[key];
        }
      } else {
        console.log('metricsSettings', 'XXXXXX');
      }

      const barChartOptions = {
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: metricsSetting.begin_at_zero,
              callback: function (value) {
                return numeral(value).format(metricsSetting.numeric_format || '0,0');
              },
            },
          }],
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return numeral(tooltipItem.yLabel).format(metricsSetting.numeric_format || '0,0');
            }
          }
        },
        elements: {
          line: {
            fill: false,
            lineTension: 0,
          }
        },
      }
      
      const chartData = {
        labels: currentKeyData.map(eachPoint => eachPoint.time_series_label),
        datasets: [
          {
            type: metricsSetting.chart_style || 'bar',
            label: metricsSetting.name || key,
            // backgroundColor: metricsSetting.background_color_hex || '#40bfc1',
            borderColor: metricsSetting.border_color_hex || '#40bfc1',
            borderWidth: metricsSetting.border_width || 1,
            fill: false,
            backgroundColor: metricsSetting.background_color_hex || '#EC932F',
            pointBorderColor: metricsSetting.background_color_hex || '#EC932F',
            pointBackgroundColor: metricsSetting.background_color_hex || '#EC932F',
            pointHoverBackgroundColor: metricsSetting.background_color_hex || '#EC932F',
            pointHoverBorderColor: metricsSetting.background_color_hex || '#EC932F',
            data: currentKeyData.map(eachPoint => eachPoint.metrics_value),
          },
        ],
        barChartOptions,
      };
      timeSeriesMetricsTransformed.push(chartData);
    });
    return timeSeriesMetricsTransformed;
  }
  render() {

    const {
      salesTimeSeriesMetrics,
      financialTimeSeriesMetrics,
      usersTimeSeriesMetrics,
      customerSupportTimeSeriesMetrics,
      fromYearMonth,
      toYearMonth,
    } = this.state;
    
    return (
      <div
        className="location_metrics_view"
      >
        <h4>Filter</h4>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <Label>From</Label>
              <Input
                type="text"
                placeholder="YYYY-MM"
                value={fromYearMonth}
                onChange={(e) => this.setState({ fromYearMonth: e.target.value })}
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <FormGroup>
              <Label>To</Label>
              <Input
                type="text"
                placeholder="YYYY-MM"
                value={toYearMonth}
                onChange={(e) => this.setState({ toYearMonth: e.target.value })}
              />
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Button color="primary" onClick={() => this.loadData()}>Run</Button>
            </FormGroup>
          </Col>
        </Row>
        <h4>Tình hình kinh doanh</h4>
        <Row>
          {salesTimeSeriesMetrics.map((metrics, index) => (
            <Col xs={12} sm={6} key={index}>
              <Bar
                data={metrics}
                width={100}
                height={50}
                options={metrics.barChartOptions}
              />
            </Col>
          ))}
        </Row>
        <h4>Tài chính</h4>
        <Row>
          {financialTimeSeriesMetrics.map((metrics, index) => (
            <Col xs={12} sm={6} key={index}>
              <Bar
                data={metrics}
                width={100}
                height={50}
                options={metrics.barChartOptions}
              />
            </Col>
          ))}
        </Row>
        <h4>User</h4>
        <Row>
          {usersTimeSeriesMetrics.map((metrics, index) => (
            <Col xs={12} sm={6} key={index}>
              <Bar
                data={metrics}
                width={100}
                height={50}
                options={metrics.barChartOptions}
              />
            </Col>
          ))}
        </Row>
        <h4>Hỗ trợ khách hàng</h4>
        <Row>
          {customerSupportTimeSeriesMetrics.map((metrics, index) => (
            <Col xs={12} sm={6} key={index}>
              <Bar
                data={metrics}
                width={100}
                height={50}
                options={metrics.barChartOptions}
              />
            </Col>
          ))}
        </Row>
      </div>
    )
  }
}